export function formatCurrency(amount, currency = 'VND') {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency
  }).format(amount);
}
export function formatVND(amount) {
  return formatCurrency(amount, 'VND');
}
export function formatPhone(phone) {
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 10) {
    return `${cleaned.slice(0, 4)} ${cleaned.slice(4, 7)} ${cleaned.slice(7)}`;
  }
  return phone;
}
export function maskPhone(phone) {
  if (phone.length < 6) return phone;
  return `${phone.slice(0, 3)}****${phone.slice(-3)}`;
}
export function formatVNDShort(amount) {
  const isNegative = amount < 0;
  const abs = Math.abs(amount);
  let result;
  if (abs >= 1000000) {
    const tr = abs / 1000000;
    result = tr % 1 === 0 ? `${tr}tr` : `${tr.toFixed(1).replace('.', ',')}tr`;
  } else if (abs >= 1000) {
    const k = abs / 1000;
    result = k % 1 === 0 ? `${k}k` : `${k.toFixed(1)}k`;
  } else {
    result = `${abs} ₫`;
  }
  return isNegative ? `-${result}` : result;
}
export function parseVND(input) {
  const cleaned = input.replace(/₫/g, '').replace(/\s/g, '').replace(/\./g, '');
  return parseInt(cleaned, 10);
}
//# sourceMappingURL=format.js.map